import React from "react";
import { inject, observer } from "mobx-react";
import { FilterStore, ITaxonomy } from "src/stores";
import { Icons } from "src/libs/assets";
import * as s from "./SelectedTaxonomiesList.module.scss";

interface Props {
  filterStore?: FilterStore;
  taxonomies?: ITaxonomy[];
}

export const SelectedTaxonomiesList = inject("filterStore")(
  observer(({ filterStore, taxonomies }: Props) => {
    const taxonomyTerms = taxonomies ?? filterStore?.selectedTaxonomies;
    return (
      <div className={s.selectedItemsContainer}>
        {taxonomyTerms?.map((selectedTaxonomy, i) => (
          <button
            key={i}
            onClick={() =>
              filterStore?.toggleOption(filterStore?.selectedTaxonomies, selectedTaxonomy)
            }
          >
            <img src={Icons.cancel_normal} alt="remove-from-filter" />
            {selectedTaxonomy?.value}
          </button>
        ))}
      </div>
    );
  })
);
